import React from "react";

export default function CalenderIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 3H21.5C23 3 23.9742 4.15734 24 5.5V21.2188C24 21.8901 23.7164 22.5135 23.2782 22.993C23.1751 23.1129 23.0462 23.2328 22.9173 23.3287C22.4017 23.7363 21.7315 24 21.0097 24H2.99033C2.26853 24 1.59828 23.7363 1.08271 23.3287C0.953813 23.2328 0.824919 23.1129 0.721804 22.993C0.283566 22.5135 0 21.8901 0 21.2188V5.5C0 3.96553 0.850161 3 2.5 3H3.5V2.18182C3.5 0.983017 4.71106 0 6 0C7.28894 0 8.5 0.983017 8.5 2.18182V3H15.5V2.18182C15.5 0.983017 16.7111 0 18 0C19.2889 0 20.5 0.983017 20.5 2.18182V3ZM20.4426 21.9495C21.3106 21.9495 22 21.3079 22 20.5V18H16V21.9495H20.4426ZM15.0128 11.9525H8.98723V8H15.0383V11.9525H15.0128ZM9 17H15.0383V13H9V17ZM8.98723 18H15V22H8.98723V18ZM8 8.03168H2V11.9762H8V8.03168ZM2 13H8V17H2V13ZM2 18L1.94255 20.5505C1.94255 21.3347 2.63191 22 3.5 22H8V18H2ZM22 17H16V13H22V17ZM16 8.03168V11.9762H22V8.03168H16ZM5.08085 2.35545C5.08085 1.8802 5.48936 1.5 6 1.5C6.51064 1.5 6.91915 1.8802 6.91915 2.35545V4.64455C6.91915 5.1198 6.51064 5.5 6 5.5C5.48936 5.5 5.08085 5.1198 5.08085 4.64455V2.35545ZM18 1.5C17.4894 1.5 17.0809 1.8802 17.0809 2.35545V4.64455C17.0809 5.1198 17.4894 5.5 18 5.5C18.5106 5.5 18.9191 5.1198 18.9191 4.64455V2.35545C18.9191 1.8802 18.5106 1.5 18 1.5Z"
        fill="#31A3AE"
      />
    </svg>
  );
}
